import React from 'react';
import { Icon } from './Icon';

/** Pager. Ported from D:\campaigning-system\src\components\ui\Pagination.tsx. */
export function Pagination({ page, pageSize, total, onPageChange, className = '', noun = 'items' }) {
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className={`flex items-center justify-between gap-3 ${className}`}>
      <p className="text-[13px] text-cos-ink-secondary">
        Showing <span className="mono font-semibold text-cos-ink">{from.toLocaleString('en-US')}</span>–
        <span className="mono font-semibold text-cos-ink">{to.toLocaleString('en-US')}</span> of{' '}
        <span className="mono font-semibold text-cos-ink">{total.toLocaleString('en-US')}</span> {noun}
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="grid h-8 w-8 place-items-center rounded-lg border border-cos-line bg-white/60 text-cos-ink-secondary transition-colors hover:border-cos-teal/40 hover:text-cos-teal-deep disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="Previous page"
        >
          <Icon name="chevron_left" className="text-[19px]" />
        </button>
        <span className="mono px-2 text-[13px] font-semibold text-cos-ink">
          {page} <span className="text-cos-ink-muted">/ {pageCount}</span>
        </span>
        <button
          onClick={() => onPageChange(Math.min(pageCount, page + 1))}
          disabled={page >= pageCount}
          className="grid h-8 w-8 place-items-center rounded-lg border border-cos-line bg-white/60 text-cos-ink-secondary transition-colors hover:border-cos-teal/40 hover:text-cos-teal-deep disabled:cursor-not-allowed disabled:opacity-40"
          aria-label="Next page"
        >
          <Icon name="chevron_right" className="text-[19px]" />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
